<template>
  <v-row>
    <v-col cols="12" lg="12" class="h-40">
      <canvas id="myChart" width="500" height="200"></canvas>
    </v-col>
  </v-row>
</template>

<script>
import Axios from "axios";
import { constants } from "../../../constants";
import Chart from "chart.js/auto";

export default {
  name: "ServiceReportCard",
  // components: { Chart },
  data: () => ({
    loaded: false,
    labels: undefined,
    datasets: undefined,
  }),
  mounted() {
    const app = this;
    Axios.get(
      constants.VUE_APP_BASEURL + "/dashboard/logbook_created"
    ).then((res) => {
      const labels = res.data.months;
      const datasets = [
        {
          label: "Aqua",
          data: res.data.aqua,
          borderWidth: 1,
          backgroundColor: "cyan",
        },
        {
          label: "Finish",
          data: res.data.finish,
          borderWidth: 1,
          backgroundColor: "green",
        },
        {
          label: "Metal",
          data: res.data.metal,
          borderWidth: 1,
          backgroundColor: "yellow",
        },
      ];

      app.loaded = true;
      drawChart({datasets, labels})
      return;

    });
  },
};
function drawChart({ datasets, labels }) {
  var ctx = document.getElementById("myChart");
  return new Chart(ctx, {
    type: "bar",
    data: {
      labels: labels,
      datasets: datasets,
    },
    options: {
      plugins: {
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: "Log Books 12 months",
        },
      },
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    },
  });
}
</script>

<style>
.h-40 {
  min-height: 60vh;
  width: 500px;
}
</style>